import { render, staticRenderFns } from "./AutocabPromotion.vue?vue&type=template&id=8abf9a24&scoped=true"
import script from "./AutocabPromotion.vue?vue&type=script&lang=js"
export * from "./AutocabPromotion.vue?vue&type=script&lang=js"
import style0 from "./AutocabPromotion.vue?vue&type=style&index=0&id=8abf9a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abf9a24",
  null
  
)

export default component.exports